import { render, staticRenderFns } from "./member-major-dialog.vue?vue&type=template&id=6b9b33e2&scoped=true"
import script from "./member-major-dialog.vue?vue&type=script&lang=js"
export * from "./member-major-dialog.vue?vue&type=script&lang=js"
import style0 from "./member-major-dialog.vue?vue&type=style&index=0&id=6b9b33e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b33e2",
  null
  
)

export default component.exports